"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialiseUseCase = void 0;
var AcornUseCase_1 = require("./AcornUseCase");
var stores_1 = require("../stores");
var inversify_1 = require("inversify");
var ioc_1 = require("../ioc");
var ioc_2 = require("../ioc");
var InitialiseUseCase = /** @class */ (function (_super) {
    __extends(InitialiseUseCase, _super);
    function InitialiseUseCase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InitialiseUseCase.prototype, "onExecute", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var globalStore, initialisers, i, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        globalStore = stores_1.GlobalStore.get();
                        initialisers = ioc_2.getCoreContainer().isBound(ioc_1.CORE_TYPES.InitialiseUseCase)
                            ? ioc_2.getCoreContainer().getAll(ioc_1.CORE_TYPES.InitialiseUseCase)
                            : [];
                        // Global initialisation things here in the future
                        // ...
                        globalStore.initialising = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < initialisers.length)) return [3 /*break*/, 5];
                        return [4 /*yield*/, initialisers[i].execute()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        if (!error_1) {
                            error_1 = new Error('Unknown Initialisation Error');
                        }
                        globalStore.error = error_1;
                        return [3 /*break*/, 7];
                    case 7:
                        globalStore.initialised = true;
                        globalStore.initialising = false;
                        return [2 /*return*/];
                }
            });
        }
    });
    InitialiseUseCase = __decorate([
        inversify_1.injectable()
    ], InitialiseUseCase);
    return InitialiseUseCase;
}(AcornUseCase_1.AcornUseCase));
exports.InitialiseUseCase = InitialiseUseCase;
//# sourceMappingURL=InitialiseUseCase.js.map